import { ForestOwnerSandboxHistoryLayout } from '@features/Framework/ForestOwnerSandbox/ForestOwnerSandboxHistoryLayout'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/framework/forestowner/$forestownerId/history')({
  component: RouteComponent,
  staticData: {
    breadcrumb: 'Historikk',
  },
})

function RouteComponent() {
  const { forestownerId } = Route.useParams()
  return <ForestOwnerSandboxHistoryLayout forestownerId={forestownerId} />
}
